module.exports = __webpack_public_path__ + "img/sepadirectdebit.d8cd26f1.png";